import { render } from "./DocumentReviewArchitecture.vue?vue&type=template&id=492b538e&scoped=true"
import script from "./DocumentReviewArchitecture.vue?vue&type=script&lang=js"
export * from "./DocumentReviewArchitecture.vue?vue&type=script&lang=js"

import "./DocumentReviewArchitecture.vue?vue&type=style&index=0&id=492b538e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492b538e"]])

export default __exports__